import {BaseEntity} from "./BaseEntity";


export class MqttClient implements  BaseEntity
{
    constructor(public id?: number,
                public username?: string,
                public password?: string,
        public accessGatewayMessages?: boolean,
        public accessTagMovements?: boolean,
        public accessTagObservations?: boolean,
        public accessEvents?: boolean,
        public accessAlarms?: boolean,
        public accessVTagSensors?: boolean,
    ) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.username = json.username;
        this.password = json.password;
        this.accessGatewayMessages = json.accessGatewayMessages;
        this.accessTagObservations = json.accessTagObservations;
        this.accessTagMovements = json.accessTagMovements;
        this.accessEvents = json.accessEvents;
        this.accessAlarms = json.accessAlarms;
        this.accessVTagSensors = json.accessVTagSensors;
    }


}
